<template>
  <footer>
    <div class="">
      <div class="footer__grass">
        <div class="footer__bees">
          <img
            class="footer__bee--first"
            src="../assets/images/bee-single.svg"
            alt="Pszczółka"
          />
          <img
            class="footer__bee--second"
            src="../assets/images/bees/bee__8.svg"
            alt="Pszczółka"
          />
          <img
            class="footer__bee--three"
            src="../assets/images/bees/bee__2.svg"
            alt="Pszczółka"
          />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterGrass",
  data() {
    return {
      title: "footer",
      currentYear: new Date().getFullYear(),
    };
  },
  methods: {
    toggleContact: function() {
      this.$emit("show-contact-section");
    },
    toggleRules: function() {
      this.$emit("show-rules-section");
    },
    togglePrivacy: function() {
      this.$emit("show-privacy-section");
    },
    toggleQA: function() {
      this.$emit("show-qa-section");
    },
  },
};
</script>
